import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LuckyWheelNavButton } from './lucky-wheel/LuckyWheelNavButton';

function NavIcon({ name }: { name: string }) {
  const common = { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', 'aria-hidden': true as const };
  switch (name) {
    case 'wallet':
      return (
        <svg {...common}>
          <rect x="3" y="6" width="18" height="13" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
          <path d="M3 10h18" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="16.5" cy="14.5" r="1.2" fill="currentColor" />
        </svg>
      );
    case 'invite':
      return (
        <svg {...common}>
          <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.8" />
          <path d="M3.5 18.5c.6-3.2 2.8-5 5.5-5s4.9 1.8 5.5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M17 8v6M14 11h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case 'casino':
      return (
        <svg {...common}>
          <rect x="4" y="3" width="11" height="15" rx="1.5" stroke="currentColor" strokeWidth="1.8" transform="rotate(-8 9.5 10.5)" />
          <rect x="9" y="5" width="11" height="15" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="14.5" cy="12.5" r="1.4" fill="currentColor" />
        </svg>
      );
    case 'menu':
      return (
        <svg {...common}>
          <path d="M5 7h14M5 12h14M5 17h14" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
        </svg>
      );
    default:
      return null;
  }
}

interface BottomNavProps {
  onOpenWheel: () => void;
}

export function BottomNav({ onOpenWheel }: BottomNavProps) {
  const { t } = useTranslation('nav');

  return (
    <nav className="bottom-nav bottom-nav-ton" aria-label="Mobile">
      <NavLink to="/cashier" className="bottom-nav-item">
        <span className="icon">
          <NavIcon name="wallet" />
        </span>
        <span className="label">{t('wallet')}</span>
      </NavLink>

      <NavLink to="/referral" className="bottom-nav-item">
        <span className="icon">
          <NavIcon name="invite" />
        </span>
        <span className="label">{t('invite')}</span>
      </NavLink>

      <LuckyWheelNavButton onOpen={onOpenWheel} />

      <NavLink to="/" end className="bottom-nav-item">
        <span className="icon">
          <NavIcon name="casino" />
        </span>
        <span className="label">{t('casino')}</span>
      </NavLink>

      <NavLink to="/menu" className="bottom-nav-item">
        <span className="icon">
          <NavIcon name="menu" />
        </span>
        <span className="label">{t('menu')}</span>
      </NavLink>
    </nav>
  );
}
